import { createContext, useContext } from "react";

export const TutorialContext = createContext(null);

export const useTutorial = () => useContext(TutorialContext);
